export const menuItems = [
  {
   title: "Markets",
   submenu: [
     {
       title: "All markets"
     },
     {
       title: "BTC-PERP"
     },
     {
       title: "ETH-PERP"
     },
     {
       title: "SOL-PERP"
     }
   ]
  },
  {
   title: "More",
   submenu: [
     {
      title: "FTT"
     },
     {
      title: "NFTS"
     },
     {
      title: "Stake"
     },
     {
      title: "OTC"
     },
     {
      title: "Vote"
     },
     {
      title: "Funding"
     },
     {
      title: "Rewards"
     },
     {
      title: "Competitions"
     },
     {
      title: "Advanced Trading"
     },
     {
      title: "Options"
     }
   ]
  },
  {
   title: "Help",
   submenu: [
     {
       title: "Support"
     },
     {
       title: "Help Center"
     },
     {
       title: "Depositing & Withdrawing Fiat"
     },
     {
       title: "How to Buy & Sell crypto"
     },
     {
       title: "Maker vs Taker fees"
     }
   ]
  }
 ];